import { useState } from 'react';

import DataTable from 'components/DataTableComponent/DataTable';

import {
  BillingPeriodUnit,
  SubscriptionStatus
} from '../../../common/contracts';
import FilterSearchCard from 'components/Filter/FilterSearchCard';
import FilterDropdownCard from 'components/Filter/FilterDropdownCard';
import { useSubscriptionsColumns } from '../hooks/use-subscriptions-columns';
import useSubscriptions from 'api/useSubscriptions';

export function SubscriptionsTable() {
  const [billingPeriod, setBillingPeriod] = useState<string>('');
  const [subscriptionStatusFilter, setSubscriptionStatusFilter] =
    useState<string>('');
  const [planName, setPlanName] = useState<string>('');
  const { columns } = useSubscriptionsColumns();
  const { getSubscriptions } = useSubscriptions({
    pageSize: 10,
    status: subscriptionStatusFilter
  });

  console.log('getSubscriptions', getSubscriptions.data);

  return (
    <div>
      <div className="flex pb-3 pt-1 gap-3">
        <FilterSearchCard
          header="Plan ID"
          isLabelSearchBy
          filterValue={planName}
          setFilterValue={(value) => setPlanName(value)}
        />

        <FilterDropdownCard
          header="Status"
          filterValue={subscriptionStatusFilter}
          setFilterValue={(value) => setSubscriptionStatusFilter(value)}
          options={[
            { label: 'Active', value: SubscriptionStatus.ACTIVE },
            { label: 'Overdue', value: SubscriptionStatus.OVERDUE },
            { label: 'Cancelled', value: SubscriptionStatus.CANCELLED },
            { label: 'Expired', value: SubscriptionStatus.EXPIRED },
            { label: 'Trial', value: SubscriptionStatus.TRIAL },
            { label: 'Pending', value: SubscriptionStatus.PENDING }
          ]}
        />
        <FilterDropdownCard
          header="Billing period"
          filterValue={billingPeriod}
          setFilterValue={(value) => setBillingPeriod(value)}
          options={[
            { label: 'Daily', value: BillingPeriodUnit.DAILY },
            { label: 'Weekly', value: BillingPeriodUnit.WEEKLY },
            { label: 'Monthly', value: BillingPeriodUnit.MONTHLY },
            { label: 'Yearly', value: BillingPeriodUnit.YEARLY }
          ]}
        />

        <FilterSearchCard
          header="Subscription ID"
          filterValue={planName}
          setFilterValue={(value) => setPlanName(value)}
        />
      </div>

      <DataTable
        data={getSubscriptions.data || []}
        columns={columns}
        rowIdIdentifier="id"
        isLoading={getSubscriptions.isLoading}
        bordered
      />
    </div>
  );
}
